/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneLoopAround from 'base/components/standalone/LoopAround';

export const DynamicStandaloneLoopAround = StandaloneLoopAround;
export type DynamicStandaloneLoopAroundProps = PropsFromComponent<typeof StandaloneLoopAround>;

export const DynamicStandaloneLoopAroundWith = (extras: DynamicStandaloneExtras): typeof StandaloneLoopAround => {
    return function DynamicStandaloneLoopAround(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'LoopAround');
        return <StandaloneLoopAround {...mergeProps({ options: { theme } }, props)} />;
    }
}